import { useContext ,useCallback ,useEffect } from "react";
import { EditorInfoContext } from "../../../../../utis/userInfoContext";

function useCanvasHook() {
    const { rectangles ,pageDimensions, } = useContext(EditorInfoContext)
    // const draw = (index, canvasRefs ,zoomLevel) => {
      const draw = useCallback((index, canvasRefs, zoomLevel) => {
    const canvas = canvasRefs.current[index];
    const ctx = canvas?.getContext("2d");

    if (!ctx || !canvas) return;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    rectangles[index]?.forEach((rect, i) => {
      const isLast = i === rectangles[index].length - 1;
  if(isLast){

  drawRectangle(ctx, rect, 1, pageDimensions, canvas, isLast);
  }

  // drawRectangle(ctx, rect, 1, pageDimensions, canvas, isLast);
});

  // };
   }, [rectangles, pageDimensions]);  // <-- ensures re-run when zoom or rectangles change


const drawRectangle = (
  ctx,
  rect,
  zoomLevel = 1,
  pageDimensions = {},
  canvas,
  highlight = false
) => {
  if (!rect?.startCoords || !rect?.currentCoords) return;

  const geometry = {
    top: Math.min(rect.startCoords.y, rect.currentCoords.y),
    left: Math.min(rect.startCoords.x, rect.currentCoords.x),
    width: Math.abs(rect.currentCoords.x - rect.startCoords.x),
    height: Math.abs(rect.currentCoords.y - rect.startCoords.y),
  };

  const { geo } = getNormalizedDimensions(
    geometry,
    zoomLevel,
    pageDimensions,
    rect,
    canvas
  );
  if (geo && geo.width > 0 && geo.height > 0) {
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.strokeStyle = highlight ? "red" : "pink";
    ctx.strokeRect(geo.left, geo.top, geo.width, geo.height);
    ctx.closePath();

    // Set text style
    ctx.fillStyle = "red";
    ctx.font = "12px Arial";
    ctx.textAlign = "center";

    // Center of the rectangle
    const centerX = geo.left + geo.width / 2;
    const centerY = geo.top + geo.height / 2;

    // ctx.fillText(infoText, centerX, centerY);
  } else {
    console.warn("Skipping invalid rect:", rect);
  }
};




    const normalizeDimensions = (val, currentScale, desiredScale) => {
        if (undefined === desiredScale) {
            desiredScale = window.objInit?.zoom_lvl || 1;
        }
        return Math.round(val * (desiredScale / currentScale));
    };

const getNormalizedDimensions = (
  geometry = {},
  zoom = 1,
  pageDimensions = {},
  element,
  canvas
) => {
  const page_w = pageDimensions.width || 800;
  const page_h = pageDimensions.height || 1000;

  const rendered_w = canvas?.offsetWidth || page_w;
  const rendered_h = canvas?.offsetHeight || page_h;

  const scaleX = typeof zoom === "object" ? zoom.value || 1 : zoom;
  const scaleY = scaleX;

  let top = Math.round((geometry.top ?? 0) * scaleY);
  let left = Math.round((geometry.left ?? 0) * scaleX);
  let height = Math.round((geometry.height ?? 0) * scaleY);
  let width = Math.round((geometry.width ?? 0) * scaleX);

  if (geometry.keep_within_page) {
    top = Math.max(0, Math.min(top, rendered_h - height));
    left = Math.max(0, Math.min(left, rendered_w - width));
  }

  const geo = {
    position: "absolute",
    top,
    left,
    width,
    height,
    fontSize: `${10 * scaleY}pt`,
    lineHeight: 1.3,
  };

  return {
    top,
    left,
    height,
    width,
    geo,
  };
};


const createDiv = (
  logicalRect,   
  pageIndex,
  canvasRefs,
  zoomLevel,
  pageDimensions
) => {
  const canvas = canvasRefs.current[pageIndex];
  if (!canvas?.parentElement) return null;

  const { geo } = getNormalizedDimensions(
    {
      top:    logicalRect.y,
      left:   logicalRect.x,
      width:  logicalRect.width,
      height: logicalRect.height,
    },
    zoomLevel,
    pageDimensions,
    /* element */ null,
    canvas
  );

  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position:      "absolute",
    top:           `${geo.top}px`,
    left:          `${geo.left}px`,
    width:         `${geo.width}px`,
    height:        `${geo.height}px`,
    pointerEvents: "none",              
    zIndex:        "999",
  });

  canvas.parentElement.appendChild(overlay);

  return overlay;
};

    return {
        draw,
        normalizeDimensions,
        createDiv
    }
}
export default useCanvasHook